import { render, staticRenderFns } from "./DamageFields.vue?vue&type=template&id=2ce9b69d&scoped=true"
import script from "./DamageFields.vue?vue&type=script&lang=ts"
export * from "./DamageFields.vue?vue&type=script&lang=ts"
import style0 from "./DamageFields.vue?vue&type=style&index=0&id=2ce9b69d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce9b69d",
  null
  
)

export default component.exports